import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import { createElement } from 'react'

import classnames from 'classnames'

import styles from './List.module.scss'

export const List: FunctionComponent<ListProps> = ({
  children,
  className,
  appearance = 'bullet',
  ...rest
}) => {
  const isOrderedList = appearance === 'number' ? true : false

  const listTag = isOrderedList ? 'ol' : 'ul'

  const props = {
    className: classnames(
      styles.list,
      {
        [styles.listOrdered]: isOrderedList,
      },
      className
    ),
    'data-testid': 'list-element',
    ...rest,
  }

  return createElement(listTag, props, children)
}

///////// IMPLEMENTATION /////////

export type ListProps = {
  /**
   * Child nodes i.e. ListItem to render inside the List component.
   */
  children: ReactNode
  /**
   * CSS class name that will be added to the List component.
   */
  className?: string
  /**
   * Provide an appearance to render List
   */
  appearance?: AppearanceType
} & HTMLProps<HTMLUListElement | HTMLOListElement>

export type AppearanceType = 'bullet' | 'number'
